<template>
  <main>
    <!-- Opening Slides -->

    <!-- <AppNavBar /> -->

    <section class="app-frame">
      <div class="frame w-full flex justify-between px-4 py-8 z-50 text-white">
          <div class="frame__inner">
            <h1 class="font-display text-xl">Pose XR</h1>
          </div>
          <h3 class="frame__logo"></h3>
          <router-link to="/launch" class="text-right">Go to Experience <i class="fal fa-long-arrow-right"></i></router-link>
          <p class="frame__credits"></p>
          <!-- <a href="https://twitter.com/codrops" class="frame__social">About</a>
          <div class="frame__sponsor">Sponsored by the <a href="https://www.vam.ac.uk/">V&A</a></div> -->
        </div>
    </section>

    <section class="gallery">
      <GalleryContainer />
    </section>


    <!-- Section -->
    <section class="intro">
      <div class="relative bg-black bg-opacity-90 z-20">
        <div class="px-4 py-16 mx-auto max-w-7xl sm:py-16 sm:px-6 lg:px-8">
          <div class="text-center">
            <h2 class="text-base font-semibold tracking-wide text-indigo-500 uppercase">
              Interactive
            </h2>
            <p class="mt-1 mb-8 text-4xl font-extrabold text-gray-100 font-display sm:text-5xl sm:tracking-tight lg:text-6xl">
              Art direct your own fashion shoot.
            </p>
            <p class="max-w-xl mx-auto mt-5 text-xl text-gray-400 mb-8">
              An original concept by FIA and dandelion + burdock, Pose XR is a virtual tool to art direct your own fashion shoot.
            </p>
            <router-link to="/launch"
              class="inline-flex items-center px-6 py-3 text-base font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
              Go to Experience <i class="fal fa-long-arrow-right ml-3"></i>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- Section - Project Logos -->
    <section class="project-logos">
      <div class="bg-white">
        <div class="px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:py-16 lg:px-8">
          <p class="text-base font-semibold tracking-wider text-center text-gray-600 uppercase">
            Created & Supported By
          </p>
          <div class="mt-6 grid grid-cols-2 gap-0.5 md:grid-cols-5 lg:mt-8">
            <div class="flex self-center justify-center col-span-1 px-8 py-8">
              <a href="https://www.fialondon.com/" target="_blank">
                <img class="max-h-12" src="/images/logos/fia-cropped-logo.png" alt="FIA" />
              </a>
            </div>
            <div class="flex self-center justify-center col-span-1 px-8 py-8">
              <a href="https://dandelion-burdock.com" target="_blank">
                <img class="max-h-12" src="/images/logos/dnb-logo.png" alt="dandelion + burdock" />
              </a>
            </div>
            <div class="flex self-center justify-center col-span-1 px-8 py-8">
              <a href="https://www.vam.ac.uk/" target="_blank">
                <img class="max-h-12" src="/images/logos/1280px-Victoria_and_Albert_Museum_Logo.svg.png" alt="V&A" />
              </a>
            </div>
            <div class="flex self-center justify-center col-span-1 px-8 py-8">
              <a href="https://www.londondesignfestival.com/" target="_blank">
                <img class="max-h-12" src="/images/logos/ldf-logo.png" alt="London Design Festival" />
              </a>
            </div>
            <div class="flex self-center justify-center col-span-1 px-8 py-8">
              <a href="https://www.volograms.com/" target="_blank">
                <img class="max-h-12" src="/images/logos/volograms-logo.png" alt="Volograms" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>


    <!-- Section - About -->
    <!-- <div class="bg-black">
      <div class="px-4 py-16 mx-auto max-w-7xl sm:py-24 sm:px-6 lg:px-8">
        <div class="text-center">
          <p class="mt-1 text-gray-100 font-display text-7xl sm:text-7xl sm:tracking-tight lg:text-7xl">
            Standard Hydrogen Electrode
          </p>
          <p class="max-w-xl mx-auto mt-5 text-xl text-gray-500">
            An original concept by FIA and dandelion + burdock, Pose XR is a virtual tool to art direct your own fashion shoot.
          </p>
        </div>
      </div>
    </div> -->


<!-- Section - Infinite Possibilites -->
<section class="infinite-possibilities">
  <div class="relative bg-gray-900 pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8">
    <div class="relative max-w-7xl mx-auto">
      <div class="text-center">
        <h2 class="text-3xl tracking-tight font-display font-extrabold text-gray-100 sm:text-7xl">
          Infinite Possibilities
        </h2>
        <p class="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
          Become a virtual art director as you style and adjust the scene parameters to create a unique moment.
        </p>
      </div>
      <div class="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
        <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
          <div class="flex-shrink-0 w-full aspect-w-1 aspect-h-1 rounded-lg-tl rounded-lg-tr overflow-hidden sm:aspect-w-2 sm:aspect-h-3">
            <img class="w-full h-full object-center object-cover" src="/images/looks/look-01.png" alt="Look 1">
          </div>
          <div class="flex-1 bg-white p-6 flex flex-col justify-between">
            <div class="flex-1 text-center">
              <p class="text-xs font-bold text-indigo-600 uppercase tracking-wider">
                  360&deg; Video
              </p>
              <a href="#" class="block mt-2">
                <p class="text-3xl font-semibold font-display text-gray-900">
                  Looks
                </p>
                <p class="mt-3 text-base text-gray-500">
                  Select between five looks.
                </p>
              </a>
            </div>
          </div>
        </div>

        <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
          <div class="flex-shrink-0 w-full aspect-w-1 aspect-h-1 rounded-lg-tl rounded-lg-tr overflow-hidden sm:aspect-w-2 sm:aspect-h-3">
            <img class="w-full h-full object-center object-cover" src="images/looks/look-02.png" alt="Look 2">
          </div>
          <div class="flex-1 bg-white p-6 flex flex-col justify-between">
            <div class="flex-1 text-center">
              <p class="text-xs font-bold text-indigo-600 uppercase tracking-wider">
                  Context
              </p>
              <a href="#" class="block mt-2">
                <p class="text-3xl font-semibold font-display text-gray-900">
                  Setting & Props
                </p>
                <p class="mt-3 text-base text-gray-500">
                  Style and adjust the scene parameters.
                </p>
              </a>
            </div>
          </div>
        </div>

        <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
          <div class="flex-shrink-0 w-full aspect-w-1 aspect-h-1 rounded-lg-tl rounded-lg-tr overflow-hidden sm:aspect-w-2 sm:aspect-h-3">
            <img class="w-full h-full object-center object-cover" src="/images/looks/look-03.png" alt="Look 3">
          </div>
          <div class="flex-1 bg-white p-6 flex flex-col justify-between">
            <div class="flex-1 text-center">
              <p class="text-xs font-bold text-indigo-600 uppercase tracking-wider">
                  Mood & Ambiance
              </p>
              <a href="#" class="block mt-2">
                <p class="text-3xl font-semibold font-display text-gray-900">
                  Lighting
                </p>
                <p class="mt-3 text-base text-gray-500">
                  Set the lighting before you capture your shot.
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Section - Volumetric Video -->
   <div class="relative pt-16 pb-32 overflow-hidden">
     <div aria-hidden="true" class="absolute inset-x-0 top-0 h-48 bg-gradient-to-b from-gray-100"></div>
     <div class="relative">
       <div class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
         <div class="px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
           <div>
             <div class="mt-6">
               <h1 class="text-4xl font-extrabold tracking-tight text-gray-900 font sm:text-6xl">
                 Volumetric video adds presence.
               </h1>
               <p class="mt-4 text-xl text-gray-500">
                 With the evolution of virtual production, we believe that "free-viewpoints" and "reality" will be key elements in helping the virtual medium succeed.
               </p>
             </div>
           </div>
         </div>
         <div class="mt-12 sm:mt-16 lg:mt-0">
           <div class="pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
             <img class="w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none" src="/images/volograms/volograms-capture.png" alt="Volograms Capture">
           </div>
         </div>
       </div>
     </div>
   </div>


    <!-- Alternating Feature Sections: FIA & dnb -->
   <div class="relative pt-16 pb-32 overflow-hidden">
     <div aria-hidden="true" class="absolute inset-x-0 top-0 h-48 bg-gradient-to-b from-gray-100"></div>
     <div class="relative">
       <div class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
         <div class="px-4 max-w-xl mx-auto sm:px-6 lg:py-32 lg:max-w-none lg:mx-0 lg:px-0">
           <div>
             <div class="mt-6">
               <h2 class="text-3xl font-extrabold tracking-tight text-gray-900">
                 The Fashion Innovation Agency
               </h2>
               <p class="mt-4 text-lg text-gray-500">
                 Based at London College of Fashion, University of the Arts London, the Fashion Innovation Agency uses emerging technologies to disrupt existing practices in the fashion and retail industries.
                 The FIA has a breathtaking portfolio of projects that have captured the imagination of the fashion and technology worlds. Trailblazers in the digital fashion space, they have shown how immersive technologies are leading us to a new era of experiential retail.
               </p>
               <div class="mt-6">
                 <a href="#" class="inline-flex place-items-center bg-gradient-to-r from-purple-600 to-indigo-600 bg-origin-border px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white hover:text-gray-200 hover:from-purple-700 hover:to-indigo-700">
                   <span>Visit FIA</span> <i class="fas fa-external-link-square-alt ml-4"></i>
                 </a>
               </div>
             </div>
           </div>
           <div class="mt-8 border-t border-gray-200 pt-6">
             <blockquote>
               <div>
                 <p class="text-base text-gray-500">
                   &ldquo;The explosion of interest in digital fashion and ‘the metaverse’ has largely, to date, focused on commerce. What has yet to be explored in any depth is the huge implications on creativity. PoseXR is a glimpse into the limitless boundaries of creating virtual worlds.&rdquo;
                 </p>
               </div>
               <footer class="mt-3">
                 <div class="flex items-center space-x-3">
                   <div class="flex-shrink-0">
                     <img class="h-6 w-6 rounded-full" src="/images/avatars/matthew-drinkwater.png" alt="Matthew Drinkwater">
                   </div>
                   <div class="text-base font-medium text-gray-700">
                     Matthew Drinkwater, Head of Fashion Innovation Agency
                   </div>
                 </div>
               </footer>
             </blockquote>
           </div>
         </div>
         <div class="mt-12 sm:mt-16 lg:mt-0">
           <div class="pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
            <video loop="loop" playsinline="playsinline" autoplay="autoplay" muted="muted" class="w-full rounded shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none">
              <source src="https://www.fialondon.com/wp-content/uploads/2020/09/Showreel-Banner.mp4" type="video/mp4">
            </video>
             <!-- <img class="w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none" src="https://tailwindui.com/img/component-images/inbox-app-screenshot-1.jpg" alt="Inbox user interface"> -->
           </div>
         </div>
       </div>
     </div>
     <div class="mt-24">
       <div class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
         <div class="px-4 max-w-xl mx-auto sm:px-6 lg:py-32 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-2">
           <div>
             <div class="mt-6">
               <h2 class="text-3xl font-extrabold tracking-tight text-gray-900">
                 dandelion + burdock
               </h2>
               <p class="mt-4 text-lg text-gray-500">
                 dandelion + burdock, a special projects company, are driven by creating culture content, launching strategy, design and production to realize award winning interactive content.
               </p>
               <div class="mt-6">
                 <a href="#" class="inline-flex place-items-center bg-gradient-to-r from-purple-600 to-indigo-600 bg-origin-border px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white hover:text-gray-200 hover:from-purple-700 hover:to-indigo-700">
                   Check out dnb <i class="fas fa-external-link-square-alt ml-4"></i>
                 </a>
               </div>
             </div>
           </div>
           <div class="mt-8 border-t border-gray-200 pt-6">
             <blockquote>
               <div>
                 <p class="text-base text-gray-500">
                   &ldquo;The advent of new and emerging technology offers exciting opportunities to alter the way that the fashion industry is making, showcasing and retailing products. The key to success lies in creating compelling brand differentiation. &rdquo;
                 </p>
               </div>
               <footer class="mt-3">
                 <div class="flex items-center space-x-3">
                   <div class="flex-shrink-0">
                     <img class="h-6 w-6 rounded-full" src="/images/avatars/niall-thompson.png" alt="Niall Thompson">
                   </div>
                   <div class="text-base font-medium text-gray-700">
                     Niall Thompson, Co-Founder
                   </div>
                 </div>
               </footer>
             </blockquote>
           </div>
         </div>
         <div class="mt-12 sm:mt-16 lg:mt-0 lg:col-start-1">
           <div class="pr-4 -ml-48 sm:pr-6 md:-ml-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
             <video loop="loop" playsinline="playsinline" autoplay="autoplay" muted="muted" class="w-full rounded shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:right-0 lg:h-full lg:w-auto lg:max-w-none" poster="/imager/s3public/pages/digital-fashion/1971/digital_fashion_still_01_1.1.1_d3867277feb154defec9b24a5714fadb_d3867277feb154defec9b24a5714fadb.webp">
              <source src="https://d2ia5m5penbc42.cloudfront.net/assets/services/digital-fashion/digital_fashion_hero_02_noAudio-720.mp4.mp4" type="video/mp4">
              <source src="https://d2ia5m5penbc42.cloudfront.net/assets/services/digital-fashion/digital_fashion_hero_02_noAudio.webmhd.webm" type="video/webm">
            </video>
             <!-- <img class="w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:right-0 lg:h-full lg:w-auto lg:max-w-none" src="https://tailwindui.com/img/component-images/inbox-app-screenshot-2.jpg" alt="Customer profile user interface"> -->
           </div>
         </div>
       </div>
     </div>
   </div>

   <!-- Section - Built With -->
   <!-- <div class="bg-gray-50">
     <div class="px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:py-16 lg:px-8">
       <div class="lg:grid lg:grid-cols-2 lg:gap-16 lg:items-center">
         <div>
           <h2 class="text-3xl font-extrabold text-gray-900 sm:text-4xl">
             Used by the world's most average companies
           </h2>
           <p class="max-w-3xl mt-3 text-lg text-gray-500">
             The project was developed in Unity to take advantage of the
             realistic, behaviorally accurate, 3D engine. We used Furioos to
             deploy the project. Furioos makes it easy to share any 3D
             application and embed it onto any website.
           </p>
         </div>
         <div class="mt-8 grid grid-cols-2 gap-0.5 md:grid-cols-3 lg:mt-0 lg:grid-cols-2">
           <div class="flex justify-center col-span-1 px-8 py-8">
             <a href="#">
               <img class="max-h-12" src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Unity_Technologies_logo.svg/1024px-Unity_Technologies_logo.svg.png" alt="Unity - Logo" />
             </a>
           </div>
           <div class="flex justify-center col-span-1 px-8 py-8">
             <a href="#">
               <img class="max-h-12" src="https://static1.squarespace.com/static/59b24f17f5e23147566b49b3/t/5bfead92b8a0457bc5ef94ae/1542619871024/Furioos_UE4_Black.png?format=1000w" alt="Furioos - Logo" />
             </a>
           </div>
         </div>
       </div>
     </div>
   </div> -->

    <Footer />
  </main>
</template>

<script>
  const GalleryContainer = () => import('@/components/gallery/GalleryContainer')
  import AppNavBar from '@/components/app/AppNavBar.vue'
  import Footer from '@/components/includes/Footer.vue'

  export default {
    name: 'home',
    components: {
      AppNavBar,
      Footer,
      GalleryContainer,
    },
  }
</script>
